// import media files

// import avatar media files
import Avatar1 from 'assets/images/avatar/avatar-1.jpg';
import Avatar2 from 'assets/images/avatar/avatar-2.jpg';
import Avatar3 from 'assets/images/avatar/avatar-3.jpg';
import Avatar4 from 'assets/images/avatar/avatar-4.jpg';
import Avatar5 from 'assets/images/avatar/avatar-5.jpg';
import Avatar6 from 'assets/images/avatar/avatar-6.jpg';
import Avatar7 from 'assets/images/avatar/avatar-7.jpg';
import Avatar9 from 'assets/images/avatar/avatar-9.jpg';
import Avatar10 from 'assets/images/avatar/avatar-10.jpg';

// import courses media files
import LaravelCourse from 'assets/images/course/course-laravel.jpg';
import GatsbyCourse from 'assets/images/course/course-gatsby.jpg';
import JavaScriptCourse from 'assets/images/course/course-javascript.jpg';
import NodeCourse from 'assets/images/course/course-node.jpg';
import ReactCourse from 'assets/images/course/course-react.jpg';
import AngularCourse from 'assets/images/course/course-angular.jpg';
import GraphQLCourse from 'assets/images/course/course-graphql.jpg';
import HTMLCourse from 'assets/images/course/course-html.jpg';

export const allcourses = [
	{
		id: 1,
		image: GatsbyCourse,
		title: 'Revolutionize how you build the web',
		date_added: 'Added on 7 July, 2020',
		instructor_name: 'Reva Yokk',
		instructor_image: Avatar7,
		enrolled: 12234
	},
	{
		id: 2,
		image: GraphQLCourse,
		title: 'Guide to Static Sites with Gatsby',
		date_added: 'Added on 6 July, 2021',
		instructor_name: 'Brooklyn Simmons',
		instructor_image: Avatar6,
		enrolled: 2000
	},
	{
		id: 3,
		image: HTMLCourse,
		title: 'The Modern HTML Courses',
		date_added: 'Added on 5 July, 2021',
		instructor_name: 'Miston Wilson',
		instructor_image: Avatar5,
		enrolled: 22345
	},
	{
		id: 4,
		image: JavaScriptCourse,
		title: 'Courses JavaScript Heading Title',
		date_added: 'Added on 5 July, 2021',
		instructor_name: 'Guy Hawkins',
		instructor_image: Avatar1,
		enrolled: 5235
	},
	{
		id: 5,
		image: NodeCourse,
		title: 'Get Start with Node Heading Title',
		date_added: 'Added on 5 July, 2021',
		instructor_name: 'Sina Ray',
		instructor_image: Avatar3,
		enrolled: 7200
	},
	{
		id: 6,
		image: LaravelCourse,
		title: 'Get Start with Laravel',
		date_added: 'Added on 5 July, 2021',
		instructor_name: 'Sobo Rikhan',
		instructor_image: Avatar9,
		enrolled: 22500
	},
	{
		id: 7,
		image: ReactCourse,
		title: 'Get Start with React',
		date_added: 'Added on 4 July, 2021',
		instructor_name: 'April Noms',
		instructor_image: Avatar2,
		enrolled: 6759
	},
	{
		id: 8,
		image: AngularCourse,
		title: 'Get Start with Angular',
		date_added: 'Added on 3 July, 2021',
		instructor_name: 'Jacob Jones',
		instructor_image: Avatar4,
		enrolled: 7234
	},
	{
		id: 9,
		image: LaravelCourse,
		title: 'Get Start with Laravel',
		date_added: 'Added on 5 July, 2021',
		instructor_name: 'Sobo Rikhan',
		instructor_image: Avatar9,
		enrolled: 6759
	},
	{
		id: 10,
		image: NodeCourse,
		title: 'Get Start with Node Heading Title',
		date_added: 'Added on 5 July, 2021',
		instructor_name: 'Sina Ray',
		instructor_image: Avatar3,
		enrolled: 22500
	},
	{
		id: 11,
		image: JavaScriptCourse,
		title: 'Courses JavaScript Heading Title',
		date_added: 'Added on 5 July, 2021',
		instructor_name: 'Guy Hawkins',
		instructor_image: Avatar10,
		enrolled: 2000
	},
	{
		id: 12,
		image: LaravelCourse,
		title: 'Get Start with Laravel',
		date_added: 'Added on 5 July, 2021',
		instructor_name: 'Sobo Rikhan',
		instructor_image: Avatar9,
		enrolled: 22500
	},
	{
		id: 13,
		image: ReactCourse,
		title: 'Get Start with React',
		date_added: 'Added on 4 July, 2021',
		instructor_name: 'April Noms',
		instructor_image: Avatar2,
		enrolled: 6759
	},
	{
		id: 14,
		image: AngularCourse,
		title: 'Get Start with Angular',
		date_added: 'Added on 3 July, 2021',
		instructor_name: 'Jacob Jones',
		instructor_image: Avatar4,
		enrolled: 5235
	},
	{
		id: 15,
		image: GatsbyCourse,
		title: 'Revolutionize how you build the web',
		date_added: 'Added on 7 July, 2020',
		instructor_name: 'Reva Yokk',
		instructor_image: Avatar7,
		enrolled: 2000
	},
	{
		id: 16,
		image: GraphQLCourse,
		title: 'Guide to Static Sites with Gatsby',
		date_added: 'Added on 6 July, 2021',
		instructor_name: 'Brooklyn Simmons',
		instructor_image: Avatar6,
		enrolled: 22500
	},
	{
		id: 17,
		image: AngularCourse,
		title: 'Get Start with Angular',
		date_added: 'Added on 3 July, 2021',
		instructor_name: 'Jacob Jones',
		instructor_image: Avatar4,
		enrolled: 6759
	},
	{
		id: 18,
		image: LaravelCourse,
		title: 'Get Start with Laravel',
		date_added: 'Added on 5 July, 2021',
		instructor_name: 'Sobo Rikhan',
		instructor_image: Avatar9,
		enrolled: 5235
	},
	{
		id: 19,
		image: NodeCourse,
		title: 'Get Start with Node Heading Title',
		date_added: 'Added on 5 July, 2021',
		instructor_name: 'Sina Ray',
		instructor_image: Avatar3,
		enrolled: 2000
	},
	{
		id: 20,
		image: JavaScriptCourse,
		title: 'Courses JavaScript Heading Title',
		date_added: 'Added on 5 July, 2021',
		instructor_name: 'Guy Hawkins',
		instructor_image: Avatar10,
		enrolled: 22500
	}
];

export const CategorySingleData = [allcourses];
